export default "__VITE_ASSET__CTkt57SU__"